export default "__VITE_ASSET__8ec4ea45__"